import { Interpolation } from "@emotion/core";
import { darken, transparentize } from "polished";
import { grid } from "../../../../design-tokens/grid";
import { Colors } from "../../../../design-tokens/colors";
import { DarkTheme, Device } from "../../../../design-tokens/media-queries";
import { Fonts } from "../../../../design-tokens/fonts";
import { Border } from "../../../../design-tokens/borders";

const sectionHeading: Interpolation = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: grid(3),
};

const tableContainer: Interpolation = {
  marginBottom: grid(4),

  [Device.Mobile]: {
    overflowX: "auto",
    width: "calc(100% + 40px)",
    marginLeft: grid(-2),
    marginRight: grid(-2),
  },
};

const table: Interpolation = {
  position: "relative",
  minWidth: grid(68),
};

const row: Interpolation = {
  display: "flex",

  "> div": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexBasis: grid(12),
    paddingLeft: grid(1),
    paddingRight: grid(1),

    [Device.Desktop]: {
      flexBasis: grid(14),
      paddingLeft: grid(2),
      paddingRight: grid(2),
    },

    ":first-of-type": {
      flex: 1,
      justifyContent: "flex-start",
      paddingLeft: grid(2),

      [Device.Desktop]: {
        paddingLeft: grid(3),
      },
    },
  },
};

const header: Interpolation = {
  position: "sticky",
  top: 0,
  height: grid(5),
  fontSize: 14,
  fontWeight: Fonts.Weight.SemiBold,
  backgroundColor: darken(0.05, Colors.LightGrey),
  zIndex: 1,

  [DarkTheme]: {
    color: transparentize(0.2, Colors.White),
    backgroundColor: Colors.DarkModeDeepBlack,
  },

  [Device.DesktopTablet]: {
    borderTopLeftRadius: Border.Radius,
    borderTopRightRadius: Border.Radius,
  },
};

const footer: Interpolation = {
  height: grid(2),
  backgroundColor: darken(0.05, Colors.LightGrey),

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeDeepBlack,
  },

  [Device.DesktopTablet]: {
    borderBottomLeftRadius: Border.Radius,
    borderBottomRightRadius: Border.Radius,
  },
};

const bodyRow: Interpolation = {
  position: "relative",
  height: grid(7),
  fontSize: 18,
  fontWeight: Fonts.Weight.Bold,
  color: Colors.Black,
  backgroundColor: Colors.LightGrey,
  borderBottom: `1px solid ${darken(0.05, Colors.LightGrey)}`,
  zIndex: 0,

  [DarkTheme]: {
    color: Colors.White,
    backgroundColor: Colors.DarkModeBlack,
    borderBottom: `1px solid ${Colors.DarkModeDeepBlack}`,
  },

  ":hover": {
    textDecoration: "none",
    backgroundColor: darken(0.02, Colors.LightGrey),

    [DarkTheme]: {
      backgroundColor: darken(0.02, Colors.DarkModeBlack),
    },
  },
};

const flag: Interpolation = {
  flexShrink: 0,
  display: "block",
  width: grid(3),
  height: grid(3),
  borderRadius: "50%",
  marginRight: grid(1.5),
  overflow: "hidden",

  img: {
    width: grid(3),
    height: grid(3),
  },
};

const label: Interpolation = {
  color: Colors.Blue,
  lineHeight: 1.25,

  [DarkTheme]: {
    color: Colors.DarkModeTextBlue,
  },
};

const styles = {
  sectionHeading,
  tableContainer,
  table,
  row,
  header,
  footer,
  bodyRow,
  flag,
  label,
};

export default styles;
